export enum TFieldGoalEvents {
  BACK = 'BACK',
  ON_FAKE = 'ON_FAKE',
  ON_FG = 'ON_FG',
  ON_FUMBLE = 'ON_FUMBLE',
  ON_REF = 'ON_REF',
  ON_RETURN = 'ON_RETURN',
  ON_FUMBLE_RECOVERY = 'ON_FUMBLE_RECOVERY',
  BACK_TO_FUMBLE_RECOVERY = 'BACK_TO_FUMBLE_RECOVERY',
  TO_YARDAGE = 'TO_YARDAGE',
  TO_RESULT = 'TO_RESULT',
  TO_START = 'TO_START',
  CONFIRM_MISS = 'CONFIRM_MISS',
  CONFIRM_MAKE = 'CONFIRM_MAKE',
  CONFIRM_TD = 'CONFIRM_TD',
  PENALTY_SELECTED = 'PENALTY_SELECTED',
  FG_MAKE_OVERTIME = 'FG_MAKE_OVERTIME',
  POSSESSION_SELECTED = 'POSSESSION_SELECTED',
  BACK_TO_SELECT_POSSESSION = 'BACK_TO_SELECT_POSSESSION',
}

export enum TFieldGoalStates {
  START_FIELD_GOAL = 'START_FIELD_GOAL',
  FIELD_GOAL_RESULT = 'FIELD_GOAL_RESULT',
  FIELD_GOAL_FUMBLE = 'FIELD_GOAL_FUMBLE',
  FIELD_GOAL_REF_EVT = 'FIELD_GOAL_REF_EVT',
  FIELD_GOAL_CONFIRM = 'FIELD_GOAL_CONFIRM',
  SELECT_YARDAGE = 'SELECT_YARDAGE',
  HANDLE_YARDAGE_TOGGLES = 'HANDLE_YARDAGE_TOGGLES',
  SELECT_POSSESSION = 'SELECT_POSSESSION',
  SELECT_DOWN_POST_PENALTY = 'SELECT_DOWN_POST_PENALTY',
}
